import classnames from "classnames";
import React, { Fragment, ReactNode } from "react";

const LoginContainer = ({
  title,
  children,
}: {
  title?: string | null;
  children?: ReactNode;
}) => {
  return (
    <Fragment>
      {title && (
        <h2
          className={classnames("h4 tw-text-center ", { "tw-mb-6": children })}
        >
          {title}
        </h2>
      )}
      {children}
    </Fragment>
  );
};

export default LoginContainer;
